import React from "react";
import './styles.scss';

const Button = ({type = 'primary', content = '', className = '', href='', style = {}}) => {
    if (href) {
        return (
            <a target={'_blank'} rel="noreferrer" href={href} className={`dl-button ${type} ${className}`} style={{...style}}>
                <span>{content}</span>
            </a>
        )
    }
    return (
        <button className={`dl-button ${type} ${className}`} style={{...style}}>
            <span>{content}</span>
        </button>
    )
}

export default Button